import React, { useState, useEffect } from "react";
import { Pagination, PaginationItem, Button } from "@mui/material";
import arrowleft from "../../../src/assests/images/arrow_left.svg";

type PaginationProps = {
  page: number;
  limit: number; // currently not used in MUI Pagination, but can be used for data fetching
  totalPages: number; // total number of pages
  onPageChange: (page: number) => void; // callback when page changes
};

export default function PaginationComponent({
  page,
  totalPages,
  onPageChange,
}: PaginationProps) {
  const [currentPage, setCurrentPage] = useState(page);

  useEffect(() => {
    setCurrentPage(page);
  }, [page]);

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
    onPageChange(value);
  };

  return (
    <div>
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={handleChange}
        renderItem={(item) => (
          <PaginationItem
            components={{
              previous: () => (
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "transparent",
                    border: "1px solid rgba(208, 213, 221, 1)",
                    borderRadius: "8px",
                    boxShadow: "none",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#000",
                    textTransform: "capitalize",
                    opacity: item.disabled ? "0.5" : "1",
                    "& :hover": { background: "#fff" },
                    "& .MuiPaginationItem-root:hover": { background: "#fff" }
                  }}
                >
                  <img
                    style={{ marginRight: "12px" }}
                    src={arrowleft}
                    alt="Previous"
                  />
                  Previous
                </Button>
              ),
              next: () => (
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "transparent",
                    border: "1px solid rgba(208, 213, 221, 1)",
                    borderRadius: "8px",
                    boxShadow: "none",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#000",
                    textTransform: "capitalize",
                    opacity: item.disabled ? "0.5" : "1",
                  }}
                >
                  Next
                  <img
                    style={{
                      marginLeft: "12px",
                      transform: "rotate(180deg)",
                    }}
                    src={arrowleft}
                    alt="Next"
                  />
                </Button>
              ),
            }}
            {...item}
          />
        )}
        sx={{
          "li:first-of-type": { position: "absolute", left: "10px" },
          "li:last-of-type": { position: "absolute", right: "10px" },
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "16px 0",
          ".Mui-selected": {
            backgroundColor: "rgba(245, 251, 255, 1) !important",
            borderRadius: "8px",
            color: "rgba(87, 163, 253, 1)",
            fontWeight: "500",
            ".MuiPaginationItem-text": {
              fontSize: "14px !important",
              fontWeight: "500",
            },
          },
        }}
      />
    </div>
  );
}